import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import {Button, Col, Form, FormGroup, FormText, Input, Label, Row, Table, Modal, ModalBody, ModalFooter, ModalHeader, InputGroup, InputGroupAddon} from 'reactstrap';
import _ from 'lodash';
import PropTypes from 'prop-types';
import {Validacao} from "../../comum/components/Validacao";
import Select from "react-select";
import SelectAsync from "../../comum/components/SelectAsync";
import {createSelectOptions} from "../../../utils/formatar";
import {Alerta} from "../../comum/components/Alerta";

@inject("store")
@observer
export class SolicitanteForm extends Component {

    static propTypes = {
        usuarioSolicitante: PropTypes.object,
        gestorSolicitante: PropTypes.object,
        onGestorSolicitanteChange: PropTypes.func,
        controller: PropTypes.object
    };

    constructor(props) {
        super(props);
        this.loginStore = this.props.store.loginStore;
    }

    renderGestorParaAdmin(){
        
        const alertaGestorSolicitante = this.props.controller.alertaGestorSolicitante;
        
        return (<FormGroup>
                    <Label>Gestor solicitante <sup>*</sup></Label>
                    <Select
                        className={this.props.controller.solicitacao.solicitacaoExcecao ? "multiple-selects-input no-buttons" : "multiple-selects-input"}
                        simpleValue
                        cacheAsyncResults={false}
                        value={this.props.controller.solicitacao.gestorSolicitante}
                        onChange={(value, options) => this.props.controller.setGestorSolicitante(value, options)}
                        valueKey={"matricula"}
                        labelKey={"labelValue"}
                        searchPromptText="Informe a matrícula para pesquisar"
                        noResultsText={"Empregado não encontrado ou já associado"}
                        placeholder="Selecione..."
                        asyncOptions={(input, callback) => this.props.controller.filtrarGestoresSolicitantes(input, callback)}/>
                    {this.props.motivoContratacao === "SUB" &&
                    <Validacao id="gestorSolicitanteAdmin" valor={this.props.controller.solicitacao.gestorSolicitante} tipo={["isRequired"]}/>
                    }
                    {alertaGestorSolicitante &&
                        <Alerta id={"alertaGestorSolicitante"} alertas={[alertaGestorSolicitante]} isBloqueante/>
                    }
                </FormGroup>)
    }

    renderGestorParaSolicitante(){
        const gestorOption = this.loginStore.usuarioLogado && this.loginStore.usuarioLogado.gestores ?
            this.loginStore.usuarioLogado.gestores.map(gestor => {
                gestor.labelValue = gestor.nome + " (" + gestor.matricula + ")";
                return gestor;
            })
        : [];
        
        const alertaGestorSolicitante = this.props.controller.alertaGestorSolicitante;

        if (_.get(this.loginStore.usuarioLogado, "gestores.length") > 1) {
            return (<FormGroup>
                    <Label>Gestor solicitante <sup>*</sup></Label>
                    <Select simpleValue
                            value={this.props.controller.solicitacao.gestorSolicitante}
                            options={gestorOption}
                            onChange={(value, options) => this.props.controller.setGestorSolicitante(value, options)}
                            valueKey={"matricula"}
                            labelKey={"labelValue"}
                            noResultsText="Nenhum resultado encontrado"
                            placeholder="Selecione..."
                    />
                    <Validacao id="gestorSolicitante" valor={this.props.controller.solicitacao.gestorSolicitante} tipo={["isRequired"]} />
                    {alertaGestorSolicitante &&
                        <Alerta id={"alertaGestorSolicitante"} alertas={[alertaGestorSolicitante]} isBloqueante/>
                    }
                    
                </FormGroup>)
        }
        else{
            return(<FormGroup>
                        <Label>Gestor solicitante</Label>
                        <Input type="text" value={this.props.controller.exibirGestorSolicitante} readOnly />
                        {alertaGestorSolicitante &&
                            <Alerta id={"alertaGestorSolicitante"} alertas={[alertaGestorSolicitante]} isBloqueante/>
                        }                        
                    </FormGroup>)
        }
    }

    renderGestorSelect(){
        return this.loginStore.usuarioLogado.perfilAdministrador && this.props.controller.solicitacao.solicitacaoExcecao ? this.renderGestorParaAdmin() : this.renderGestorParaSolicitante();
    }

    render() {

        const gestorOption = this.loginStore.usuarioLogado && this.loginStore.usuarioLogado.gestores ?
            this.loginStore.usuarioLogado.gestores.map(gestor => {
                gestor.labelValue = gestor.nome + " (" + gestor.matricula + ")";
                return gestor;
            })
            : [];

        const alertaGestorSolicitante = this.props.controller.alertaGestorSolicitante;
            
        return (
            <div>
                <h4>Solicitante</h4>
                <Row>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Nome do solicitante</Label>
                            <Input type="text" value={_.get(this.props, "usuarioSolicitante.nome")} readOnly />
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={6} lg={4} className={this.props.controller.exibeGestorSolicitanteAdminExcecao ? "hide-item" : "show-item"}>
                        {_.get(this.loginStore.usuarioLogado, "gestores.length") > 1 ? (
                        <FormGroup>
                            <Label>Gestor solicitante <sup>*</sup></Label>
                            <Select simpleValue
                                    value={this.props.controller.solicitacao.gestorSolicitante}
                                    options={gestorOption}
                                    onChange={(value, options) => this.props.controller.setGestorSolicitante(value, options)}
                                    valueKey={"matricula"}
                                    labelKey={"labelValue"}
                                    noResultsText="Nenhum resultado encontrado"
                                    placeholder="Selecione..."
                            />
                            {!this.props.controller.exibeGestorSolicitanteAdminExcecao &&
                                <Validacao id="gestorSolicitante" valor={this.props.controller.solicitacao.gestorSolicitante} tipo={["isRequired"]}/>
                            }
                            {alertaGestorSolicitante &&
                                <Alerta id={"alertaGestorSolicitante"} alertas={[alertaGestorSolicitante]} isBloqueante/>
                            }
                        </FormGroup>
                        ) : (
                            <FormGroup>
                                <Label>Gestor solicitante</Label>
                                <Input type="text" value={this.props.controller.exibirGestorSolicitante} readOnly />
                                {alertaGestorSolicitante &&
                                    <Alerta id={"alertaGestorSolicitante"} alertas={[alertaGestorSolicitante]} isBloqueante/>
                                }
                            </FormGroup>
                        )}
                    </Col>
                    <Col xs={12} md={6} lg={4} className={this.props.controller.exibeGestorSolicitanteAdminExcecao ? "show-item" : "hide-item"}>
                        <FormGroup>
                            <Label>Gestor solicitante <sup>*</sup></Label>
                            <Select
                                className={this.props.controller.solicitacao.solicitacaoExcecao ? "multiple-selects-input no-buttons" : "multiple-selects-input"}
                                simpleValue
                                cacheAsyncResults={false}
                                value={this.props.controller.solicitacao.gestorSolicitante}
                                onChange={(value, options) => this.props.controller.setGestorSolicitante(value, options)}
                                valueKey={"matricula"}
                                labelKey={"labelValue"}
                                searchPromptText="Informe a matrícula para pesquisar"
                                noResultsText={"Empregado não encontrado ou já associado"}
                                placeholder="Selecione..."
                                asyncOptions={(input, callback) => this.props.controller.filtrarGestoresSolicitantes(input, callback)}/>
                            {this.props.controller.exibeGestorSolicitanteAdminExcecao &&
                                <Validacao id="gestorSolicitanteAdmin" valor={this.props.controller.solicitacao.gestorSolicitante} tipo={["isRequired", "empregadoGestor"]}/>
                            }
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Centro de custo - gestor solicitante</Label>
                            <Input type="text" value={_.get(this.props, "gestorSolicitante.centroCusto", "")} readOnly />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>N1</Label>
                            <Input type="text" value={_.get(this.props, "gestorSolicitante.nomeArea", "")} readOnly />
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>N2</Label>
                            <Input type="text" value={_.get(this.props, "gestorSolicitante.nomeCentral", "")} readOnly />
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>N3</Label>
                            <Input type="text" value={_.get(this.props, "gestorSolicitante.nomeDivisao", "")} readOnly />
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>N4</Label>
                            <Input type="text" value={_.get(this.props, "gestorSolicitante.nomeDepartamento", "")} readOnly />
                        </FormGroup>
                    </Col>
                </Row>
            </div>
        )
    }
}